import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const dynamicTicketConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default dynamicTicketConfig;
